import { render } from "./FollowupIndicator.vue?vue&type=template&id=5495edb4&scoped=true"
import script from "./FollowupIndicator.vue?vue&type=script&lang=js"
export * from "./FollowupIndicator.vue?vue&type=script&lang=js"

import "./FollowupIndicator.vue?vue&type=style&index=0&id=5495edb4&scoped=true&lang=css"

import exportComponent from "/var/www/html/nchsaet-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5495edb4"]])

export default __exports__